var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, IconButton, Layout, MultiColumnList, TextField } from '@folio/stripes/components';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { dateFromYYYYMMDD, dateToYYYYMMDD, maxDate, minDate } from '../../utils/DateUtils';
import { getDateTimeFields, getMainConflictError, getNameFieldError, isOuterRowConflicted, outerRowSorter, updateRowState } from './ExceptionFieldUtils';
import cssHiddenErrorField from './hiddenErrorField.css';
import css from './HoursAndExceptionFields.css';
import HoursOfOperationFieldRowFormatter from './MCLRowFormatter';
import OpenClosedSelect from './OpenClosedSelect';
import RowType from './RowType';
export var ExceptionField = function (props) {
    /** Must add at least one empty row, or MCL will not render properly */
    var _a = useState([]), rowStates = _a[0], _setRowStates = _a[1];
    var setRowStates = function (newRowStates) {
        _setRowStates(newRowStates);
        props.input.onChange(newRowStates);
    };
    var intl = useIntl();
    var fieldRefs = props.fieldRefs;
    var _currentCountState = useState(0);
    var currentCount = _currentCountState[0];
    var setCurrentCount = _currentCountState[1];
    // Initially sort and use values as source of rows
    useEffect(function () {
        var rows = __spreadArray([], props.input.value, true);
        // do nothing if there are no openings to render/parse
        if (rows.length === 0) {
            return;
        }
        rows.sort(outerRowSorter);
        setRowStates(rows);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // controls whether empty/invalid error messages should be shown
    var isDirty = !!(props.submitAttempted || props.meta.touched);
    var contents = rowStates.map(function (row, realIndex) {
        var _a;
        if (!(row.i in fieldRefs.startDate)) {
            fieldRefs.startDate[row.i] = {};
            fieldRefs.startTime[row.i] = {};
            fieldRefs.endDate[row.i] = {};
            fieldRefs.endTime[row.i] = {};
        }
        var dateTimeFields = row.rows.map(function (innerRow, innerRowRealIndex) {
            return getDateTimeFields({
                props: props,
                row: row,
                innerRow: innerRow,
                realIndex: realIndex,
                innerRowRealIndex: innerRowRealIndex,
                fieldRefs: fieldRefs,
                isDirty: isDirty,
                rowStates: rowStates,
                setRowStates: setRowStates
            });
        });
        return {
            rowState: row,
            name: (React.createElement(TextField, { ariaLabel: intl.formatMessage({ id: 'ui-calendar.calendarForm.exceptions.column.name' }), marginBottom0: true, required: true, fullWidth: true, value: row.name, onBlur: function () { return props.input.onBlur(); }, onChange: function (e) {
                    updateRowState(rowStates, setRowStates, realIndex, {
                        name: e.target.value
                    });
                }, className: cssHiddenErrorField.hiddenErrorFieldWrapper, error: getNameFieldError(props.meta.touched, props.error, row.i) })),
            status: (React.createElement(OpenClosedSelect, { value: row.type, onBlur: props.input.onBlur, onChange: function (newData) {
                    if (newData.type === RowType.Closed) {
                        var min = minDate(row.rows
                            .filter(function (_a) {
                            var startDate = _a.startDate;
                            return startDate !== undefined;
                        })
                            .map(function (_a) {
                            var startDate = _a.startDate;
                            return dateFromYYYYMMDD(startDate);
                        }));
                        var max = maxDate(row.rows
                            .filter(function (_a) {
                            var endDate = _a.endDate;
                            return endDate !== undefined;
                        })
                            .map(function (_a) {
                            var endDate = _a.endDate;
                            return dateFromYYYYMMDD(endDate);
                        }));
                        newData.rows = [
                            {
                                i: row.lastRowI + 1,
                                startDate: min === null ? undefined : dateToYYYYMMDD(min),
                                startTime: undefined,
                                endDate: max === null ? undefined : dateToYYYYMMDD(max),
                                endTime: undefined
                            }
                        ];
                    }
                    updateRowState(rowStates, setRowStates, realIndex, newData);
                } })),
            startDate: (React.createElement(Layout, { className: "full flex flex-direction-column ".concat(css.fieldListWrapper) }, dateTimeFields.map(function (r) { return r.startDate; }))),
            startTime: (React.createElement(Layout, { className: "full flex flex-direction-column ".concat(css.fieldListWrapper) }, dateTimeFields.map(function (r) { return r.startTime; }))),
            endDate: (React.createElement(Layout, { className: "full flex flex-direction-column ".concat(css.fieldListWrapper) }, dateTimeFields.map(function (r) { return r.endDate; }))),
            endTime: (React.createElement(Layout, { className: "full flex flex-direction-column ".concat(css.fieldListWrapper) }, dateTimeFields.map(function (r) { return r.endTime; }))),
            actions: (React.createElement(Layout, { className: "full flex centerContent" },
                React.createElement(IconButton, { icon: "plus-sign", "aria-disabled": row.type === RowType.Closed, className: classNames((_a = {},
                        _a[css.disabledIconButton] = row.type === RowType.Closed,
                        _a)), onClick: function () {
                        if (row.type === RowType.Closed)
                            return;
                        var newRows = __spreadArray(__spreadArray([], row.rows, true), [
                            {
                                i: row.lastRowI + 1,
                                startDate: undefined,
                                startTime: undefined,
                                endDate: undefined,
                                endTime: undefined
                            }
                        ], false);
                        updateRowState(rowStates, setRowStates, realIndex, {
                            rows: newRows,
                            lastRowI: row.lastRowI + 1
                        });
                    } }),
                React.createElement(IconButton, { icon: "trash", onClick: function () {
                        var newRowStates = __spreadArray([], rowStates, true);
                        newRowStates.splice(realIndex, 1);
                        setRowStates(newRowStates);
                        props.input.onBlur();
                    } }))),
            isConflicted: isOuterRowConflicted(props.error, row.i)
        };
    });
    contents.push({
        rowState: {
            i: -1,
            name: '',
            type: RowType.Open,
            lastRowI: 0,
            rows: []
        },
        name: (React.createElement(Button, { marginBottom0: true, onClick: function () {
                var newRowStates = __spreadArray([], rowStates, true);
                newRowStates.push({
                    i: currentCount,
                    type: RowType.Open,
                    name: '',
                    lastRowI: 0,
                    rows: [
                        {
                            i: 0,
                            startDate: undefined,
                            startTime: undefined,
                            endDate: undefined,
                            endTime: undefined
                        }
                    ]
                });
                currentCount++;
                setCurrentCount(currentCount);
                setRowStates(newRowStates);
            } },
            React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.addRowButton" }))),
        status: undefined,
        startDate: undefined,
        startTime: undefined,
        endDate: undefined,
        endTime: undefined,
        actions: undefined,
        isConflicted: false
    });
    var conflictError = getMainConflictError(props.error);
    return (React.createElement(React.Fragment, null,
        React.createElement(MultiColumnList, { interactive: false, rowMetadata: ['isConflicted', 'rowState'], columnIdPrefix: "exceptions", columnMapping: {
                name: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.name" })),
                status: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.status" })),
                startDate: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.startDate" })),
                startTime: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.startTime" })),
                endDate: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.endDate" })),
                endTime: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.endTime" })),
                actions: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.exceptions.column.actions" }))
            }, columnWidths: {
                name: '22%',
                status: '12%',
                startDate: '15%',
                startTime: '15%',
                endDate: '15%',
                endTime: '15%',
                actions: '6%'
            }, contentData: contents, getCellClass: function (defaultClasses, rowData) {
                var _a;
                return classNames(defaultClasses, css.cellWrapper, (_a = {},
                    _a[css.conflictCell] = rowData.isConflicted,
                    _a));
            }, rowFormatter: HoursOfOperationFieldRowFormatter }),
        conflictError));
};
export default ExceptionField;
